module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAAIVBMVEX/3LkAAADzy6P/6Kr/3br/27b/477/3Lj/17f/4bjxyZ9baEafAAAACnRSTlMzAJkEKyMbEyAM2qSvhQAAAO5JREFUKM9107FKA0EUheFfze4mncNotJSUVg74ABERLVfwAcwbrGBjF8EHSGefMk+Zzd5JDpdhT7eH77IDc4dg+f+Al5/8YWX8Y0idVMY1qM3lN6c0x3IOysrK2IJSpaG8xuV9KD99WR/KG/D56ssH1yzgOeCnz3d3TAPRwfvdFhJzDw/lL5ce9uM8sSkgM7oC0tAWkIolsHCQST6coDucoMY8zHMeLjMVZEKbqSAVHUYFadhgVJAZVxgV5IxbjAqyImJUkERYGxWsA+ERfC5GrrhchrG1KRdsdBX7dOpetd6nf03TsVT7podQPJk9hxVIH/3/qDkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./images/baseintrov2/check2.png
// module id = 570
// module chunks = 0